<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-line-height`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34 6a1 1 0 011 1v2a1 1 0 01-1 1H21v31a1 1 0 01-1 1h-2a1 1 0 01-1-1V9.999L4 10a1 1 0 01-1-1V7a1 1 0 011-1h30zm6.739.426l.06.097 4.033 7.118a.84.84 0 01.137.291l.02.11.011.107-.01.121a.824.824 0 01-.394.613l-.12.055-.08.026a.826.826 0 01-.112.024l-.058.008-.06.004h-2.165L42 33h2.167c.04 0 .078.007.117.012l.06.011.131.039.12.055c.21.124.342.33.386.555l.014.106.005.073-.01.108a.85.85 0 01-.158.4L40.8 41.476c-.166.295-.49.573-.8.517-.31.056-.634-.222-.8-.517l-4.032-7.117a.853.853 0 01-.157-.4L35 33.85l.003-.03a.835.835 0 01.402-.704l.12-.055.08-.026.1-.023c.05-.006.088-.013.128-.013H38l.001-18-2.198-.001-.097-.012-.101-.023-.08-.026-.12-.055a.835.835 0 01-.39-.578l-.008-.063L35 14.15l.01-.108a.863.863 0 01.1-.31l.058-.09L39.2 6.523c.166-.294.49-.572.8-.516.275-.05.562.164.739.42z"/></svg>
</template>
<script>

export default {
  name: 'IconLineHeight',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
